<template>
  <Modal v-model="show" title="修改项目" :closable="false" :mask-closable="false" width="600px">
    <Form ref="formData" :model="formData" :rules="rules" :label-width="120">
      <FormItem prop="name" label="项目名称">
        <Input type="text" v-model.trim="formData.name" placeholder="请输入" />
      </FormItem>
      <FormItem prop="introduce" label="项目介绍">
        <Input type="textarea" v-model.trim="formData.introduce" placeholder="请输入" />
      </FormItem>
      <FormItem prop="life" label="项目周期(天)">
        <Input type="number" v-model.trim="formData.life" placeholder="请输入" />
      </FormItem>
      <FormItem prop="progress" label="项目进度(%)">
        <Input type="number" v-model.trim="formData.progress" placeholder="请输入" />
      </FormItem>
      <!-- <FormItem label="演示地址">
        <Input type="text" v-model.trim="formData.show_link" placeholder="请输入" />
      </FormItem> -->
    </Form>
    <template #footer>
      <Button type="default" @click="show = false">取消</Button>
      <Button type="primary" @click="handleSubmit('formData')" :loading="loading">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { Form, FormItem, Input, Modal, Button, Message } from 'view-design'
import { IsNumbers } from '@/utils/index'
export default {
  components: { Form, FormItem, Input, Modal, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    detail: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      formData: {
        name: '',
        introduce: '',
        life: undefined
      },
      loading: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }
        ],
        introduce: [
          {
            required: true,
            message: '请输入项目介绍',
            trigger: 'blur'
          }
        ],
        life: [
          {
            required: true,
            type: 'number',
            message: '请输入正确的项目周期',
            validator: IsNumbers,
            trigger: 'blur'
          }
        ],
        progress: [
          {
            required: false,
            type: 'number',
            message: '请输入正确的项目进度',
            validator: IsNumbers,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.formData.progress > 100) {
            Message.error('项目进度不能大于100%')
            return
          }
          this.handleOk()
        }
      })
    },
    async handleOk() {
      const params = {
        uriCode: 'API023',
        id: this.formData.id,
        life: +this.formData.life,
        introduce: this.formData.introduce,
        progress: +this.formData.progress,
        name: this.formData.name,
        show_link: this.formData.show_link,
        code_link: this.formData.code_link
      }

      try {
        this.loading = true
        await this.$fetch(params)
      } finally {
        this.loading = false
        this.show = false
        this.$emit('ok')
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.$refs['formData'].resetFields()
      } else {
        this.formData = { ...this.detail }
        this.formData.life = +this.formData.life
      }
    }
  }
}
</script>
